import Api, {SearchResultItem} from "./api";
import {CostbookRow} from "../state/costbookRow";
import OidcManager from "./oidcManager";

export interface IAreaCostsModification {
    postalCode: string;
    area: string;
    equipment: number;
    labor: number;
    material: number;
}

export interface IContentIndexItem
{
    index : number;
    level : number;
    text : number;
}

export interface KeywordSearchItem
{
    id : number;
    index : number;
    page : number;
    isFake : boolean;
    isGroup: boolean;
    text: string;
    links: Array<KeywordLink>;
}

export interface CraftCode
{
    code : string;
    description : string;
    hourlyWadge : number;
    hourlyWadgeRaw : number;
}


export interface KeywordLink
{
    page : number;
    rowIndex : number;
}

export default class CostbooksApi extends Api {
    
    constructor(oidc: OidcManager, address: string) {
        super(oidc, address);
    }
    
    
    searchCostbooks(options: DevExpress.data.LoadOptions) : JQueryPromise<{data: KeywordSearchItem[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);

        return super.get("/api/books", command);
    }
    
    searchUnits(options: DevExpress.data.LoadOptions) : JQueryPromise<{data: KeywordSearchItem[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);

        return super.get("/api/data/units", command);
    }

    searchUnit(key: any) : JQueryPromise<KeywordSearchItem[]> {

        let command = this.loadOptionsToActionParams({
            filter: this.filterByKey("id",  key)
        }, false);

        return super.get("/api/data/units", command).then((data: any) => {
            return data!.data[0];
        });
    }

    searchCraftCodes(options: DevExpress.data.LoadOptions, postalCode: string) : JQueryPromise<{data: CraftCode[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);
        command.postalCode = postalCode;

        return super.get("/api/data/crafts", command);
    }

    searchCraftCode(key: any, postalCode: string) : JQueryPromise<CraftCode[]> {

        let command = this.loadOptionsToActionParams({
            filter: this.filterByKey("code",  key)
        }, false);
        command.postalCode = postalCode;

        return super.get("/api/data/crafts", command).then((data: any) => {
            return data!.data[0];
        });
    }

    createSearchByContentDataSource(bookId: () => number) : DevExpress.data.DataSource {
        return super.createDataSource("/api/book/content", ((operation, ajaxSettings) => {
            ajaxSettings.data.bookId = bookId();
        }));
    }


    loadCostbookRows(command: { 
        bookId: number, 
        postalCode: string | null, 
        skip?: number, 
        take?: number,
        requireTotalCount: boolean,
        modifiedEquipment: boolean,
        modifiedLabor: boolean,
        modifiedMaterial: boolean }) : JQueryPromise<{data: CostbookRow[], totalCount: number}> {
        return super.get("/api/book/rows", command);
    }

    searchRowsByText(options: DevExpress.data.LoadOptions) : JQueryPromise<{data: SearchResultItem[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);

        return super.get("/api/book/search", command);
    }

    searchRowsByContent(options: DevExpress.data.LoadOptions) : JQueryPromise<{data: any[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);

        return super.get("/api/book/content", command);
    }    

    getPages(options: DevExpress.data.LoadOptions): JQueryPromise<{ data: any[], totalCount: number }> {

        let command = this.loadOptionsToActionParams(options, false);

        return super.get("/api/book/pages", command);
    }    

    searchRowsByIndex(options: DevExpress.data.LoadOptions) : JQueryPromise<{data: KeywordSearchItem[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);

        return super.get("/api/book/keywords", command);
    }

    getCostModifications(command: {postalCode: string}): JQueryPromise<IAreaCostsModification> {
        return super.get("/api/data/costModifications", command);
    }

    getRow(id: number, 
           bookId: number, 
           postalCode: string, 
           modifiedEquipment: boolean,
           modifiedLabor: boolean,
           modifiedMaterial: boolean ): JQueryPromise<CostbookRow | undefined> {
        if (postalCode == "") postalCode = "null";
        return super.get(`/api/book/row/${id}/${postalCode}/${modifiedEquipment}/${modifiedLabor}/${modifiedMaterial}?bookId=${bookId}`, {});
    }

    getRowIndex(pageNumber: number, bookId: number): JQueryPromise<number | undefined> {
        return super.get(`/api/book/row/getRowIndex/${pageNumber}/${bookId}`, {});

    }

}


// WEBPACK FOOTER //
// ./ClientApp/services/api/costbooks-api.ts